import { Box, Divider, Checkbox } from "@mui/material";

import React, { useContext, useEffect, useState } from "react";
import { UserContext } from "../../..";
import PlayerCards from "../PlayerCards";
import EllipsisContent from "../../../../../Common/Component/EllipsisContent";

const TeamWithPlayer = ({ player }: any) => {
  const {
    setSelectedPlayer,
    selectedPlayer,
    selectAllTeamPlayers,
    setSelectAllTeamPlayers,
  }: any = useContext(UserContext);
  const [selectAllPlayer, setSelectAllPlayer] = useState(false);
  useEffect(() => {
    const filtered = selectedPlayer.filter((item: any) =>
      player.players?.find((ele: any) => ele?.player_id == item)
    );
    if (filtered?.length === 0) {
      setSelectAllPlayer(true);
      const arrayTobeSubmit = [...selectAllTeamPlayers, player.team_id];

      const uniqueNames = arrayTobeSubmit.filter(
        (val: any, id: any, array: any) => {
          return array.indexOf(val) == id;
        }
      );

      setSelectAllTeamPlayers(uniqueNames);
    } else {
      setSelectAllPlayer(false);
    }
  }, []);
  return (
    <Box>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          mt: 3,
        }}
      >
        <EllipsisContent
          text={player.team_name}
          fontWeight="700"
          sx={{ textTransform: "none", fontStyle: "normal" }}
        />

        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            position: "sticky",
            bgcolor: "white",
            top: -8,
            zIndex: 10,
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              ml: 2,
              whiteSpace: "nowrap",
            }}
          >
            Select All
          </Box>
          <Checkbox
            checked={
              selectAllPlayer || selectAllTeamPlayers.includes(player.team_id)
            }
            onChange={(e) => {
              if (e.target.checked) {
                const filtered = selectedPlayer.filter(
                  (item: any) =>
                    !player.players.find((ele: any) => ele?.player_id == item)
                );
                if (filtered?.length == 0) {
                  setSelectAllPlayer(true);
                } else {
                  setSelectAllPlayer(false);
                }
                const arrayTobeSubmit = [
                  ...selectAllTeamPlayers,
                  player.team_id,
                ];

                const uniqueNames = arrayTobeSubmit.filter(
                  (val: any, id: any, array: any) => {
                    return array.indexOf(val) == id;
                  }
                );
                setSelectAllTeamPlayers(uniqueNames);
                setSelectedPlayer(filtered);

                setSelectAllPlayer(true);
              } else {
                const removeTeam = selectAllTeamPlayers?.filter(
                  (el: any) => el != player.team_id
                );
                setSelectAllTeamPlayers(removeTeam);
                setSelectAllPlayer(false);
              }
            }}
          />
        </Box>
      </Box>
      <Divider sx={{ borderColor: "black", my: 0.5 }} />
      <Box
        sx={{
          display: selectAllPlayer ? "none" : "block",
          overflowY: "scroll",
        }}
      >
        <PlayerCards players={player.players} />
      </Box>
    </Box>
  );
};
export default TeamWithPlayer;
